import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { lightTheme, darkTheme } from "../../../../../theme/Theme";
import CustomSearch from "../../../../../utils/CustomSearch/CustomSearch";
import { useSelector } from "react-redux";
import { Button } from "pepsico-ds";
import {
  commonTextStyle,
  commonButtonStyle,
} from "../../../../PotatoProtection/LargeScreen/Landing/potatoprotectstyle";
export const CommonBuilderListHeader = ({
  title = "Current Pages",
  handleSearch,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isDarkTheme = useSelector((state) => state.theme);

  return (
    <Box
      sx={{
        display: "flex",
        padding: "var(--Spacing-spacing-8, 8px)",
        alignItems: isMobile ? "" : "center",
        alignSelf: "stretch",
        flexDirection: isMobile ? "column" : "",
        gap: isMobile ? "12px" : "",
        justifyContent: isMobile ? "" : "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          flex: "1 0 0",
        }}
      >
        <Typography
          sx={{
            color: isDarkTheme
              ? darkTheme.textColorLayer2
              : lightTheme.textColorLayer2,
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
            fontSize: "var(--Font-Size-H5, 24px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H5, 32px)",
          }}
        >
          {title}
        </Typography>
      </Box>
      <CustomSearch handleSearch={handleSearch} />
    </Box>
  );
};

export const CommonBuilderListButton = ({ title, onClick }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isDarkTheme = useSelector((state) => state.theme);
  const isMedium = useMediaQuery("(max-width:850px)");
  return (
    <Box
      sx={{
        display: "flex",
        padding: "var(--Spacing-spacing-8, 8px)",
        paddingBottom: "16px",
        alignItems: "center",
        alignSelf: "stretch",
        justifyContent: isMobile ? "" : "flex-end",
        flexDirection: isMedium ? "column" : "",
        gap: isMedium ? "14px" : "16px",
        background: isDarkTheme
          ? darkTheme.backgroundColorLayer1
          : "var(--Tokens-Background-Layer-01, #FBFCFE)",
        boxShadow: "0px -2px 0px 0px #D7E5F8 inset",
      }}
    >
      <Button
        style={{ ...commonButtonStyle, width: isMedium ? "100%" : "" }}
        iconTrailing="note_add"
        size="medium"
        onClick={onClick}
      >
        <Typography sx={commonTextStyle}>{title}</Typography>
      </Button>
    </Box>
  );
};

export const CommonBuilderListTitle = ({ title }) => {
  return (
    <Typography
      sx={{
        color: "var(--Tokens-Text-Primary, #3A3A3A)",
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
        fontSize: "var(--Font-Size-H3, 32px)",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "var(--Line-Height-H3, 44px)",
      }}
    >
      {title}
    </Typography>
  );
};
